import type { FC } from "react";
import { useTranslation } from "react-i18next";

import { MapLibrePlaceInfoHintStyled } from "./maplibre-place-info.styled";

/** Says what a click does while place info is on; `status` reads it out when the mode turns on. */
export const MapLibrePlaceInfoHint: FC = () => {
  const { t } = useTranslation();

  return (
    <MapLibrePlaceInfoHintStyled role="status">
      {t("ui.PLACE_INFO_HINT")}
      <span className="place-info-hint-exit">
        {t("ui.PLACE_INFO_EXIT_HINT")}
      </span>
    </MapLibrePlaceInfoHintStyled>
  );
};
